<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Bookings</h3>
        <v-spacer></v-spacer>

        <v-btn
          class="mb-auto mr-3"
          @click.prevent="toggleAdvanceSearch"
          dark
          fab
          color="secondary"
        >
          <v-icon>mdi-magnify</v-icon></v-btn
        >

        <v-dialog
          v-if="modelPermissions.create"
          fullscreen
          persistent
          v-model="dialog"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-auto"
              dark
              fab
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
          </template>
          <booking-dialog
            v-if="dialog"
            :bookings="bookings"
            :item="item"
            :close="close"
          ></booking-dialog>
        </v-dialog>
      </v-card-title>

      <v-data-table
        :server-items-length="bookings.total"
        :loading="loading"
        :headers="bookingHeaders"
        :items="bookings.data"
        :options.sync="options"
        :items-per-page="10"
      >
        <template v-slot:top>
          <v-expansion-panels disabled multiple v-model="advanceSearch" flat>
            <v-expansion-panel v-for="(item, i) in 1" :key="i">
              <v-expansion-panel-content>
                <v-row>
                  <v-toolbar flat>
                    <v-text-field
                      clear-icon
                      clearable
                      v-model.lazy="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                    ></v-text-field>
                  </v-toolbar>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
          <v-btn text @click="editItem(item)" color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-if="isAdmin" v-slot:item.payment_details="{ item }">
          <v-btn
            text
            color="primary"
            :to="{ name: 'BookingPaymentDetails', params: { id: item.id } }"
          >
            <v-icon left>mdi-shield-lock</v-icon>Payment details
          </v-btn>
        </template>
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteItem(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template
          v-if="modelPermissions.view"
          v-slot:item.view_invoice="{ item }"
        >
          <v-btn text @click="viewInvoice(item)" color="primary">
            <v-icon left>mdi-link</v-icon> View Invoice
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Drafts</h3>
      </v-card-title>

      <!-- ... (previous code) -->

      <v-data-table
        :server-items-length="images.total"
        :loading="loading"
        :headers="imageHeaders"
        :items="images"
        :options.sync="imageOptions"
        :items-per-page="10"
      >
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteImage(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template
          v-if="modelPermissions.view"
          v-slot:item.view_invoice="{ item }"
        >
          <v-btn text @click="viewImage(item)" color="primary">
            <v-icon left>mdi-link</v-icon> View Image
          </v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="deleteDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Confirm Delete</v-card-title>
          <v-card-text>
            Are you sure you want to delete draft with ID of
            {{ deletingImage ? deletingImage.id : '' }}?
          </v-card-text>

          <v-card-actions>
            <v-btn @click="cancelDelete" color="primary">Cancel</v-btn>
            <v-btn @click="confirmDelete" color="error">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ... (remaining code) -->
    </v-card>
  </v-row>
</template>

<script>
import BookingDialog from './BookingDialog'
import { axios, Strings } from '../../../utils'
import { mapGetters } from 'vuex'
export default {
  name: 'BookingIndex',
  components: {
    BookingDialog
  },
  data() {
    return {
      advanceSearch: [],
      baseURL: Strings.baseUrl,
      dialog: false,
      loading: false,
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Booking',
          align: 'start',
          value: 'business_name'
        },
        { text: 'Edit', align: 'center', value: 'edit', sortable: false },
        { text: 'Delete', align: 'center', value: 'delete', sortable: false },
        {
          text: 'View Invoice',
          align: 'center',
          value: 'view_invoice',
          sortable: false
        }
      ],

      bookings: [],
      options: {},
      item: {},
      search: '',
      images: [],
      imageOptions: {},
      // ... (previous code)

      imageHeaders: [
        // Define headers for the images table
        { text: 'id', align: 'start', value: 'id' },
        {
          text: 'Business/Client Name',
          align: 'start',
          value: 'business_name'
        },
        { text: 'Email', align: 'start', value: 'email' },
        { text: 'Phone', align: 'start', value: 'phone' },
        // ... (add more headers as needed)
        {
          text: 'Delete',
          align: 'center',
          value: 'delete',
          sortable: false
        },
        {
          text: 'View Image',
          align: 'center',
          value: 'view_invoice',
          sortable: false
        }
      ],
      deleteDialog: false,
      deletingImage: null

      // ... (remaining code)
    }
  },
  methods: {
    getImages() {
    this.loading = true;
    axios.get(`api/admin/images`).then(res => {
        console.log(res.data.images);
        // Instead of replacing the array, update its elements
        this.images.splice(0, this.images.length, ...res.data.images);
        this.loading = false;
    });
},

    deleteImage(item) {
      this.deletingImage = item
      this.deleteDialog = true
    },
    cancelDelete() {
      this.deleteDialog = false
      this.deletingImage = null
    },

    confirmDelete() {
      this.deleteDialog = false
      if (this.deletingImage) {
        axios
          .delete(`api/admin/images/${this.deletingImage.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.$notify({
                text: 'Image deleted successfully',
                type: 'success'
              })
              this.getImages() // Reload data in v-data-table
            }
          })
          .catch(err => {
            console.log(err)
            this.$notify({
              text: 'An error occurred while deleting the image',
              type: 'error'
            })
          })
        this.deletingImage = null
      }
    },

    viewImage(item) {
      // You might need to adjust the URL based on your route and parameters
      window.open(
        `${Strings.baseUrl}/booking_invoice_demo?key=${item.key}`,
        '_blank'
      )
    },
    toggleAdvanceSearch() {
      if (this.advanceSearch.length === 1) {
        this.advanceSearch = []
        // this.category = ''
        // this.suburb = ''
      } else {
        this.advanceSearch = [0]
      }
    },
    close() {
      this.item = {}
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getBookings() {
      this.loading = true
      console.log('getting bookings')
      axios
        .get(
          `api/admin/booking-invoices?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}`
        )
        .then(res => {
          this.bookings = res.data
          console.log(this.bookings)
          this.loading = false
          console.log('done')
        })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.id}`)) {
        console.log('deleting booking with id ', item.id)
        axios
          .delete(`api/admin/booking-invoices/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getBookings()
            }
          })
          .catch(err => console.log(err))
      }
    },
    viewInvoice(item) {
      window.open(
        `${this.baseURL}/booking-invoices/${item.id}?key=${item.key}`,
        '_blank'
      )
    }
  },
  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    isAdmin() {
      return this.$store.getters['permissions/getRole'] === 'admin'
    },
    bookingHeaders() {
      return this.isAdmin
        ? [
            ...this.headers,
            {
              text: 'Payment details',
              value: 'payment_details',
              sortable: false
            }
          ]
        : this.headers
    },
    modelPermissions() {
      return this['permissions/getModelPermissions']('booking_invoice')
    }
  },
  watch: {
    options: {
      handler() {
        this.getBookings()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getBookings()
      },
      deep: true
    },
    search: {
      handler() {
        this.getBookings()
      },
      deep: true
    },
    imageOptions: {
      handler() {
        this.getImages()
      },
      deep: true
    }
  }
}
</script>

<style scoped></style>
